module.exports = __webpack_public_path__ + "media/images/okra-offers/rewards-spend-04-9fe62ade242a55ec9ec9937d16a73862.png";